import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'msh-base-wrapper',
  imports: [],
  template: ``,
})
export class Base<Child> implements OnDestroy {
  $destroy: Subject<boolean> = new Subject()
  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.complete();
  }
}
